import React from 'react';
import { Col, Row } from 'reactstrap';
import dayjs from 'dayjs';

const SummarySection = ({ filters = {}, rightCanvasBtn }) => {
	const dateRange = filters.date_range || [];
	const hasDateRange = dateRange.length === 2 && dateRange[0] && dateRange[1];

	return (
		<React.Fragment>
			<Row>
				<Col xs={12}>
					<div className="d-flex align-items-lg-center flex-lg-row flex-column">
						<div className="flex-grow-1">
							{hasDateRange && (
								<div className="d-flex align-items-center gap-2 mb-3 mb-lg-0 flex-wrap">
									<span className="mb-0 text-muted">Filtros aplicados:</span>
									<span>Rango de Fechas:</span>
									<span className="badge bg-primary fs-10">
										{dayjs(dateRange[0]).format('DD-MM-YYYY')} -{' '}
										{dayjs(dateRange[1]).format('DD-MM-YYYY')}
									</span>
								</div>
							)}
						</div>

						<div className="mt-3 mt-lg-0">
							<form action="#">
								<Row className="g-3 mb-0 align-items-center">
									<div className="col-auto">
										<button
											type="button"
											className="btn btn-label btn-primary"
											onClick={rightCanvasBtn}
										>
											<i className="ri-filter-fill label-icon"></i> Filtros
										</button>
									</div>
								</Row>
							</form>
						</div>
					</div>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default SummarySection;
